import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import userSettingEnum from '../../../constants/enums/user-setting-enum';
import { useStore } from '../../../contexts/store-provider';
import {
  getTenantIdFromLocalStorage,
  getUserId,
} from '../../../helpers/localstorage-helper';
import { IFormModalProps } from '../../../models/forms/IForm';
import { IReactSelectOption } from '../../../models/ICommon';
import DefaultModal from '../../../shared-components/modal/default-modal';
import { formatMessage } from '../../../translations/format-message';
import ReorderOperatorListDetailForm from '../forms/reorder-operator-list-detail-form';

interface IProps extends IFormModalProps {
  processOptions: IReactSelectOption[];
  onSubmitReorder?: () => void;
}

const ReorderOperatorListDetail = (props: IProps) => {
  const { activeTrayManagementStore, processStore, operatorStore } = useStore();
  const {
    GetAllProcessService,
    allFactoryProcess,
    setCheckedColumns,
    getAllProcessState,
  } = processStore;

  const {
    allAssignedTasks,
    allAssignedTasksWithoutAssignRemove,
    GetAssignedProcessListService,
    getAssignedProcessListState,
    resetGetAssignedProcessListState,
  } = operatorStore;

  const {
    SaveProcessOrderService,
    saveProcessOrderState,
    resetSaveProcessOrderState,
  } = activeTrayManagementStore;

  // useEffect(() => {
  //   // GetAllProcessService(
  //   //   Number(getTenantIdFromLocalStorage())
  //   //   // ,localStorage.getItem('process_order') || ''
  //   // );
  //   GetAssignedProcessListService(
  //     Number(getUserId()),
  //     userSettingEnum.OperatorTaskOrder,
  //     userSettingEnum.HiddenProcessList
  //   );
  // }, []);

  useEffect(() => {
    if (saveProcessOrderState.error) {
      toast.error(formatMessage(saveProcessOrderState.error));
      resetSaveProcessOrderState();
    }
  }, [saveProcessOrderState.error]);

  const onSubmitForm = (values: any) => {
    setCheckedColumns(
      values.map((item) => ({
        ShortName: item.shortName,
        IsHidden: item.IsHidden,
      }))
    );
    const payload = Array.from(new Set(values.map((value) => value.id))).join(',');
    SaveProcessOrderService({
      SettingKey: userSettingEnum.OperatorTaskOrder,
      ProcessOrder: payload,
      HideSettingKey: userSettingEnum.HiddenProcessList,
      ProcessId: values
        .filter((item) => item.IsHidden)
        .map((value) => value.id)
        .join(','),
    });
    // localStorage.setItem('process_order', payload);
    props.onSubmitReorder();
    props.modalClosed();
  };

  const onModalClosed = () => {
    props.modalClosed();
  };

  return (
    <React.Fragment>
      <DefaultModal
        id={props.id}
        className=""
        addHeader="reorder_process"
        updateHeader="reorder_process"
        onModalClosed={onModalClosed}
        isLoading={getAllProcessState.inProgress}
        // size="sm"
      >
        <ReorderOperatorListDetailForm
          id={-1}
          initialValues={{ processOrder: props.processOptions }}
          isLoading={getAllProcessState.inProgress}
          onModalClosed={onModalClosed}
          submitHandler={onSubmitForm}
          operatorProcessOrder={allAssignedTasksWithoutAssignRemove}
        />
      </DefaultModal>
    </React.Fragment>
  );
};

export default observer(ReorderOperatorListDetail);
